// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"88f7c7f6","899":"0519c3d2","937":"9a8f2e47"}[chunkId] + ".chunk.css";
};